<template>

       <span class="MainLogo"><img src="@/assets/imgs/Logo.png"></span>

</template>

<script>
export default {

}
</script>

<style scoped>
.MainLogo{
    font-size:30px;
    text-align:center
}
</style>
